import {
  IAfterGuiAttachedParams,
  IDoesFilterPassParams,
} from 'ag-grid-community';
import { CustomFilterProps, useGridFilter } from 'ag-grid-react';
import React, { useCallback, useRef, useState } from 'react';
import { filterStyles } from './styles';

export default ({ model, onModelChange, colDef }: CustomFilterProps) => {
  const refInput = useRef<HTMLInputElement>(null);
  const [rangeSelect, setRangeSelect] = useState<string>('eq');

  const doesFilterPass = useCallback(
    (params: IDoesFilterPassParams) => {
      const filterText: string = model;
      const price_values: number = Object.values(
        params.data.prices
      )[0] as number;
      switch (rangeSelect) {
        case 'eq':
          return price_values === parseInt(filterText);
        case 'lt':
          return price_values < parseInt(filterText);
        case 'gt':
          return price_values > parseInt(filterText);
        default:
          return true;
      }
    },
    [model, rangeSelect]
  );

  const afterGuiAttached = useCallback((params?: IAfterGuiAttachedParams) => {
    if (!params || !params.suppressFocus) {
      refInput.current?.focus();
    }
  }, []);

  // register filter handlers with the grid
  useGridFilter({
    doesFilterPass,
    afterGuiAttached,
  });

  return (
    <div style={filterStyles.container}>
      <select
        value={rangeSelect}
        style={filterStyles.input}
        onChange={(e) => {
          onModelChange(model);
          setRangeSelect(e.target.value);
        }}
      >
        <option value='eq'>Equals to</option>
        <option value='gt'>Greater than</option>
        <option value='lt'>Less than</option>
      </select>
      <input
        ref={refInput}
        type='number'
        style={filterStyles.input}
        value={model || ''}
        onChange={({ target: { value } }) =>
          onModelChange(value === '' ? null : value)
        }
        placeholder='Search...'
      />
    </div>
  );
};
